import * as React from "react"
import { cn } from "@/lib/utils"

export function Select({
  value,
  onValueChange,
  children,
  className,
  ...props
}: {
  value?: string
  onValueChange?: (value: string) => void
  children: React.ReactNode
  className?: string
} & Omit<React.ComponentProps<"select">, "value" | "onChange" | "children" | "className">) {
  return (
    <select
      {...props}
      value={value}
      onChange={(e) => onValueChange?.(e.target.value)}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
    >
      {children}
    </select>
  )
}

export function SelectOption({ value, children }: { value: string; children: React.ReactNode }) {
  return <option value={value}>{children}</option>
}